import { FlexBox, Text } from '@dixa/lib-shared-habla';
import type { SearchUser } from 'lib-shared-types-api';
import { User } from 'lib-shared-types-api';

import { getUserDisplayName } from 'utils/user';

import { ContactSearchInput } from './components/contactSearchInput/contactSearchInput';

export type SelectContactProps = {
  /** The target contact that are being merged into */
  targetContact: User;
  /** When a contact is selected */
  onContactChange: (contact: SearchUser) => void;
};

/** Select contact is a contact selection component */
export const SelectContact = ({
  targetContact,
  onContactChange,
}: SelectContactProps): JSX.Element => {
  const targetContactDisplayName = getUserDisplayName(targetContact);

  const handleOnChange = async (contact: SearchUser) => {
    onContactChange(contact);
  };

  return (
    <FlexBox flexDirection="column" gap="300">
      <Text.Paragraph>
        Select which contact you want to merge with{' '}
        <strong>{targetContactDisplayName}</strong>.
      </Text.Paragraph>

      <ContactSearchInput onChange={handleOnChange} />
    </FlexBox>
  );
};
